import React, { ReactNode, useContext, useState } from "react";
import { getLast7DaysRange } from "src/util/Util";

export interface DateRange {
  fromDate: string | null;
  toDate: string | null;
}

const DateRangeContext = React.createContext<
  | {
      dateRange: DateRange | undefined;
      setDateRange: (dateRange: DateRange) => void;
      setSelectedDomains: (selectedDomains: string[]) => void;
      selectedDomains: string[];
      setSelectedMobileAppIds: (selectedMobileAppIds: string[]) => void;
      selectedMobileAppIds: string[];
      dashboardReportData: any;
      setDashboardReportData: (any) => void;
      setIsFilterOpen: (any) => void;
      isFilterOpen: boolean;
      hasManualDomainSelection: boolean;
      setHasManualDomainSelection: (value: boolean) => void;
      hasManualMobileAppIdSelection: boolean;
      setHasManualMobileAppIdSelection: (value: boolean) => void;
      topN: number;
      setTopN: (value: number) => void;
    }
  | undefined
>(undefined);

export const useDateRange = () => {
  const context: any = useContext(DateRangeContext);
  if (!context) {
    throw new Error("useDateRange must be used within a DateRangeProvider");
  }
  return context;
};

interface DateRangeProviderProps {
  children: ReactNode;
}

const DateRangeProvider: React.FC<DateRangeProviderProps> = ({ children }) => {
  const initialRange = getLast7DaysRange();
  const [dateRange, setDateRange] = useState<DateRange>({
    fromDate: initialRange?.fromDate,
    toDate: initialRange?.toDate,
  });
  const [selectedDomains, setSelectedDomains] = useState<string[]>([]);
  const [selectedMobileAppIds, setSelectedMobileAppIds] = useState<string[]>([]);
  const [dashboardReportData, setDashboardReportData] = useState<any>();
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
  const [hasManualDomainSelection, setHasManualDomainSelection] = useState<boolean>(false);
  const [hasManualMobileAppIdSelection, setHasManualMobileAppIdSelection] = useState<boolean>(false);
  const [topN, setTopN] = useState<number>(50);
  return (
    <DateRangeContext.Provider
      value={{
        dateRange,
        setDateRange,
        selectedDomains,
        setSelectedDomains,
        selectedMobileAppIds,
        setSelectedMobileAppIds,
        dashboardReportData,
        setDashboardReportData,
        isFilterOpen,
        setIsFilterOpen,
        hasManualDomainSelection,
        setHasManualDomainSelection,
        hasManualMobileAppIdSelection,
        setHasManualMobileAppIdSelection,
        topN,
        setTopN,
      }}
    >
      {children}
    </DateRangeContext.Provider>
  );
};

export default DateRangeProvider;
